import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto w-full overflow-hidden" data-id="element-538">
      <div className="px-4 py-6" data-id="element-539">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-540">
          <div className="flex items-center gap-2" data-id="element-541">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-8 w-auto object-contain" data-id="element-542" />
          </div>

          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-543">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>

          <div className="flex gap-4 text-sm text-gray-600 dark:text-gray-400" data-id="element-544">
            <Link to="/terms" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-545">
              Términos
            </Link>
            <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-546">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}